import { isObjectEmpty, valueCheck } from 'helpers/Utility';
import {
  rehydrateFamilyInfo,
  rehydrateKtpAddressDetails,
  rehydrateOccupationInfo,
  rehydratePersonInfo,
  setAccountRayaInformation,
  setApplicationDetails,
  setBankCode,
  setDocumentDetails,
  setEktp,
  setEktpImg,
  setLoanAmount,
  setNpwpImg,
  setTenure
} from 'store/actions';
import {
  setCustomerName,
  setRespPayrollDetails,
  setWhitelistAddress
} from 'store/actions/loanApply';

/**
 * to handle rehydrate state from fetch application details
 * @param {*} dispatch
 * @param {*} applicant
 * @param {*} ktp
 * @param {*} payrollDetails
 * @param {*} accountRayaInformation
 * @param {*} maritalStatusReference
 * @param {*} contactInformation
 */
const handleFetchRehydrate = (
  dispatch,
  applicant = {},
  ktp = {},
  payrollDetails = {},
  accountRayaInformation = {},
  maritalStatusReference = {},
  contactInformation = {},
  respPayrollDetails = {},
  isSecondApply,
  appStatus
) => {
  const actions = [
    {
      condition: applicant,
      fn: () =>
        dispatch(rehydratePersonInfo(applicant, maritalStatusReference, ktp))
    },
    {
      condition: ktp,
      fn: () => dispatch(rehydrateKtpAddressDetails(ktp))
    },
    {
      condition:
        isSecondApply === 'N'
          ? appStatus === 'PAY_SAVED' || appStatus === 'CON_SAVED'
            ? payrollDetails
            : {}
          : payrollDetails,
      fn: () =>
        dispatch(
          rehydrateOccupationInfo(
            payrollDetails,
            accountRayaInformation,
            ktp,
            respPayrollDetails
          )
        )
    },
    {
      condition: contactInformation,
      fn: () => dispatch(rehydrateFamilyInfo(contactInformation))
    },
    {
      condition: respPayrollDetails,
      fn: () => {
        dispatch(setRespPayrollDetails(respPayrollDetails));
        dispatch(setCustomerName(respPayrollDetails.nameWL));
        dispatch(setWhitelistAddress(respPayrollDetails.addressWL, applicant));
      }
    }
  ];

  actions.forEach(({ condition, fn }) => {
    if (!isObjectEmpty(condition)) fn();
  });
};

/**
 * to handle fetch document details
 * @param {*} dispatch
 * @param {*} doc
 * @returns
 */
export const handleFetchDocument = (dispatch, doc) => {
  if (!doc) return;
  const img = doc?.file?.replace(/(?:\\[rn]|[\r\n]+)+/g, '');
  const docKey = valueCheck(doc?.docKey);

  dispatch(setEktpImg(String.raw`data:image/jpeg;base64,${img}`));
  dispatch(setDocumentDetails(doc));
  dispatch(setEktp(docKey));
};

/**
 * to handle fetch account raya information
 * @param {*} dispatch
 * @param {*} account
 * @returns
 */
export const handleFetchAccountRaya = (dispatch, account) => {
  if (!account) return;
  if (account.fileNpwp) {
    const npwpImg = account.fileNpwp.replace(/(?:\\[rn]|[\r\n]+)+/g, '');
    dispatch(setNpwpImg(String.raw`data:image/jpeg;base64,${npwpImg}`));
  }
  dispatch(setAccountRayaInformation(account));
};

/**
 * to handle fetch application details
 * @param {*} dispatch
 * @param {*} data
 * @returns
 */
export const handleFetchApplicationDetails = (dispatch, data, getState) => {
  const app = data.applicationDetails;
  if (!app) return;

  dispatch(setLoanAmount(app.requestedLoanAmount));
  dispatch(setTenure(app.requestedTenor));
  dispatch(setApplicationDetails(app));
  dispatch(setBankCode(app.bankCode));

  const isSecondApply = getState().loanApply.appInqRes?.isSecondApply ?? 'N';
  const status = app.applicationStatus?.cmCode;
  const needsRehydrate = [
    'APP_CREATED',
    'PAYROLL_APP',
    'KTP_SAVED',
    'PER_SAVED',
    'PAY_SAVED',
    'CON_SAVED',
    'LOAN_CREATED',
    'LOAN_PAID'
  ].includes(status);

  const existingOccupationInfo = getState().loanApply.occupationInfo;

  const payrollDetailsNew = {
    ...data.payrollDetails,
    companyName: existingOccupationInfo?.companyName,
    companyName2: existingOccupationInfo?.companyName2
  };

  if (needsRehydrate) {
    handleFetchRehydrate(
      dispatch,
      data.applicantDetails,
      data.ktpAddressDetails,
      payrollDetailsNew,
      data.accountRayaInformation,
      data.contactInformation?.maritalStatusReference,
      data.contactInformation,
      data.respPayrollDetails,
      isSecondApply,
      status
    );
  }
};
